import React from 'react';
import { Label, Table } from 'semantic-ui-react';

const HazardStatementsCell = ({ rowValues, entryRecord, index }) => {
  let hazardStatements = [];
  const rowValue = rowValues[entryRecord.key];
  if (rowValue !== 'null' && typeof rowValue !== 'undefined') {
    rowValue.split(';').forEach(stat => {
      hazardStatements.push(
        <Label basic style={{ fontWeight: 'normal' }} key={rowValues.ID + index + stat}>
          {stat}
        </Label>
      );
    });
  }

  return (
    <Table.Cell key={rowValues.ID + index} className="tableCell tableCellReducedPadding2">
      {rowValue !== 'null' && hazardStatements}
    </Table.Cell>
  );
};

export default HazardStatementsCell;
